import { useState, useCallback } from 'react';

type UseControllableToggle = {
    controlledValue?: boolean;
    onChange?: (value: boolean) => void;
};

export function useControllableToggle({ controlledValue, onChange }: UseControllableToggle) {
    const [internalValue, setInternalValue] = useState(false);
    const isControlled = controlledValue !== undefined;
    const value = isControlled ? controlledValue : internalValue;

    const toggle = useCallback(() => {
        const next = !value;
        if (!isControlled) {
            setInternalValue(next);
        }
        onChange?.(next);
    }, [value, isControlled, onChange]);

    return { value, toggle };
}
